<template>
    <a id="file_main" :href="filePath" target="_blank">
        <div id="file_head">
            <img id="file_image" v-if="type === 'image'" :src="filePath">
            <i v-if="type === 'video'" class="fas fa-file fc-gray-dark"></i>
            <i v-if="type === 'sound'" class="fas fa-file fc-gray-dark"></i>
            <i v-if="type === 'text'" class="fas fa-file fc-gray-dark"></i>
            <i v-if="type === 'other'" class="fas fa-file fc-gray-dark"></i>
        </div>
        <P id="file_name" class="ff-varela fs-small">
            {{ data.name }}
        </P>
    </a>
</template>

<script>
    export default {
        name: "file",
        props: ['data'],
        computed: {
            type(){
                let re = /(?:\.([^.]+))?$/;
                let images = ['jpg', 'png', 'jpeg'];
                let videos = ['mp4', 'gif', 'webm', 'mov'];
                let sounds = ['mp3'];
                let texts = ['txt', 'docx', 'gbx'];
                let extention = this.data.name.substr(this.data.name.lastIndexOf('.') + 1);
                extention = extention.toLowerCase();
                if(images.includes(extention)){
                    return 'image'
                }else if(videos.includes(extention)){
                    return 'video'
                }else if(sounds.includes(extention)){
                    return 'sound'
                }else if(texts.includes((extention))){
                    return 'text'
                }else{
                    return 'other'
                }
            },
            bucketPath(){
                return this.$store.getters['Fs/get_bucketPath']
            },
            bucket(){
                return this.$store.getters['Fs/get_bucket']
            },
            filePath(){
                return process.env.VUE_APP_JOAT_URL + '/fs/buckets/' + this.bucket.hash + '/files?path=' + this.bucketPath + '/' + this.data.name
            }
        },
    }
</script>

<style scoped>
    #file_main{
        display: flex;
        height: 100%;
        width: 100%;
        flex-direction: column;
        align-items: center;
    }
    #file_name{
        text-overflow: ellipsis;
        overflow: hidden;
        text-align: center;
        width: 120px;
        height: 1.2em;
        white-space: nowrap;
        padding-top: 10px;
        margin: 0;
    }
    #file_head{
        display: flex;
        height: 60%;
        width: 100%;
        justify-content: center;
        align-items: center;
        font-size: 50px;

    }
    #file_image{
        max-width: 100px;
        max-height: 100%;
    }
</style>
